import { Search, Filter, Plus } from "lucide-react";
import { Input } from "@/components/ui/input";

export interface NotificationHeaderProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onFilterClick: () => void;
  onNewNotification?: () => void;
}

export function NotificationHeader({
  searchTerm,
  onSearchChange,
  onFilterClick,
  onNewNotification,
}: NotificationHeaderProps) {
  return (
    <div className="flex gap-[602px] items-start w-full">
      {/* Title Section */}
      <div className="flex flex-col gap-[2px] items-start leading-normal w-[301px]">
        <p className="font-['Plus_Jakarta_Sans'] font-bold text-[24px] text-white w-[301px]">
          Lista de todos contratos
        </p>
        <p className="font-['Plus_Jakarta_Sans'] font-normal text-[#d1d1d1] text-[14px] w-[301px]">
          Filtre os usuários por categoria ou sessão
        </p>
      </div>

      {/* Actions Section */}
      <div className="flex gap-[10px] items-center">
        {/* Search Input */}
        <div className="border border-[#5d5d5d] border-solid box-border flex gap-[90px] h-[50px] items-center px-[20px] py-[10px] rounded-[10px] w-[227px]">
          <Input
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Procurar..."
            className="border-0 h-auto p-0 bg-transparent focus-within:ring-0"
            end={<Search className="size-[24px] text-white shrink-0" />}
          />
        </div>

        {/* Filter Button */}
        <button
          onClick={onFilterClick}
          className="border border-[#5d5d5d] border-solid box-border flex gap-[20px] h-[50px] items-center px-[20px] py-[10px] rounded-[10px] w-[117px] transition-colors hover:bg-white/10"
          aria-label="Filtrar notificações"
        >
          <p className="font-['Plus_Jakarta_Sans'] font-normal leading-normal text-[#f6f6f6] text-[16px] whitespace-pre">
            Filtro
          </p>
          <Filter className="size-[24px] text-white" />
        </button>

        {/* New Notification Button (Optional) */}
        {onNewNotification && (
          <button
            onClick={onNewNotification}
            className="bg-[#7846FF] box-border flex gap-[3px] h-[50px] items-center justify-center px-[10px] py-[10px] rounded-[10px] w-[209px] transition-colors hover:bg-[#6839E6]"
            aria-label="Solicitar contrato"
          >
            <Plus className="size-[24px] text-[#F5F2FF]" />
            <p className="font-['Plus_Jakarta_Sans'] font-bold leading-normal text-[#f5f2ff] text-[16px] whitespace-pre">
              Solicitar Contrato
            </p>
          </button>
        )}
      </div>
    </div>
  );
}
